import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from "react-router-dom";
import { compose } from 'redux';
import { connect } from 'react-redux';
import { LoginRequired } from '../../../hoc/LoginRequired.jsx';
import notifier from '../../../../../components/notifier';
import { getPaymentDataForUpdate, updatePaymentData } from '../../../actions/payment-data';
import PaymentDataForm from './PaymentDataForm.jsx';


const PaymentDataUpdateForm = ({ initialValues, getPaymentDataForUpdate, updatePaymentData }) => {
  const { id } = useParams();

  useEffect(() => {
    getPaymentDataForUpdate(id);
  }, [])

  const handleFormSubmit = async (formData) => {
    const response = await updatePaymentData(id, formData);
    if (response) {
      notifier.success(gettext('Платежная информация успешно изменена.'));
    }
  };

  return <>
    <h1>{ initialValues.name || gettext('Изменить') }</h1>
    <PaymentDataForm onSubmit={ handleFormSubmit } initialValues={ initialValues } />
  </>
};

PaymentDataUpdateForm.PropTypes = {
  initialValues: PropTypes.object.isRequired,

  getPaymentDataForUpdate: PropTypes.func.isRequired,
  updatePaymentData: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    initialValues: state.paymentData.initialValues
  }
};

export default compose(
  connect(mapStateToProps, { getPaymentDataForUpdate, updatePaymentData }),
  LoginRequired,
)(PaymentDataUpdateForm);
